export const initSuitSlider = () => {
  const slider = document.querySelector('[data-suit-slider]');
  const prevEl = document.querySelector('[data-suit-prev]');
  const nextEl = document.querySelector('[data-suit-next]');
  if (!slider || !prevEl || !nextEl) {
    return;
  }
  const swiper = new Swiper(slider, {
    spaceBetween: 20,
    slidesPerView: 1,
    loop: true,
    navigation: {
      prevEl,
      nextEl,
    },
  });
};
